export const lila = '#ad8bd4'
export const harlequin = '#3ceda3'
export const turquoise = '#5dcbe9'
export const daddy = '#979dad'
export const silver = '#b3bcc7'
export const diamond = '#e9eff3'
export const corail = '#ff987e'
export const lavender = '#7b8df6'
export const energy = '#f7d85b'
export const muddy = '#d4b18b'
export const conifer = '#86E04B'
export const razzleDazzle = '#e276ec'
export const sanMarino = '#3e6ba9'
export const manhattan = '#feb64f'
export const pastel = '#f99d56'
export const manzana = '#d7e95d'
export const pictonBlue = '#3cdaed'

export const red = '#ee4a4a'
export const meadow = '#36d693'
export const aquamarine = '#69e1ae'
export const gold = '#ffbf40'
export const sunny = '#fcd188'
export const galaxy = '#515166'
export const tuna = '#49495c'
export const white = '#ffffff'

export const error = '#ee4a4a'
export const warning = '#f5a623'

export const sandyBrown = '#f59f6f'
export const monteCarlo = '#83c8b0'
export const steelGray = '#242038'

export const averagePassword = '#f39941'

export const unknown = '#2d3036'
export const unknown2 = '#38384B'
export const unknown3 = '#5a5a71'
export const unknown4 = '#49495b'

export const banks = [
  harlequin,
  pictonBlue,
  energy,
  lila,
  corail,
  lavender,
  manzana,
  galaxy,
  muddy
]

export const contracts = {
  'lifeinsurance': turquoise,
  'k_lifeinsurance': turquoise,
  'savings': lavender,
  'k_savings': lavender,
  'k_market': energy,
  'k_perp': galaxy,
  'perp': galaxy,
  'per': galaxy,
  'k_per': galaxy,
  'pea': corail,
  'k_pea': corail,
  'checking': lila,
  'deposit': lila,
  'card': lila,
  'joint': lila,
  'market': energy,
  'loan': muddy,
  'pee': sanMarino,
  'k_pee': sanMarino,
  'perco': manhattan,
  'k_perco': manhattan,
  'article83': razzleDazzle,
  'k_article83': razzleDazzle,
  'rsp': manzana,
  'mortgage': muddy,
  'consumer_credit': '#6B5F49',
  'revolving_credit': '#60585A',
  'realestate': conifer,
  'capitalisation': gold,
  'k_capitalisation': gold
}

export const realEstates = {
  'principal_residence': conifer,
  'secondary_residence': '#5F8D4A',
  'rental_investment': '#4F6A4B'
}

export const enveloppes = {
  'wealth': turquoise,
  'real_estate': conifer
}

export const map = [
  [0, '#D4F8E8'],
  [0.5, '#5FD7A3'],
  [1, '#08775F']
]

export const continentsAllocation = {
  africa: '#A6DCC9',
  asia: '#8DE2C5',
  europe: '#00795D',
  latinAmerica: '#35D694',
  northAmerica: '#00BB8B',
  oceania: '#CEF6E6',
  others: '#BBFCDF'
}

export const alloc = {
  'stock': corail,
  'bond': gold,
  'cash': lila,
  'other': lavender,
  'diversified': lavender,
  'unknown': lavender,
  'euroFund': meadow,
  'realEstate': steelGray,
  'savings': meadow,
  'usStock': muddy,
  'frStock': corail,
  'otherStock': sanMarino
}
